import React, { useState } from 'react'
import API from '../../../../../services/API'
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Modal,
  Stack,
} from '@mui/material'
import BigModal from '../../../../../components/Modals/BigModal'

const MedicalDrawing = React.memo(({ module }) => {
  const [image, setImage] = useState(null)
  const [loading, setLoading] = useState(null)
  const [fullScreen, setFullScreen] = useState(false)
  API.post('/gets3downloadurl', {
    key: module.awsMedicalDrawing,
    ACL: 'public-read',
  })
    .then((res) => setImage(res.data))
    .finally(() => setLoading(false))

  return image ? (
    <Grid item xs={12} lg={6}>
      {loading && <CircularProgress />}
      <Box
        component="img"
        src={image}
        maxHeight={200}
        sx={{ cursor: 'pointer' }}
        onClick={() => setFullScreen(true)}
      />
      <BigModal
        autoWidth
        open={fullScreen}
        onClose={() => setFullScreen(false)}
      >
        <Stack>
          <Box component="img" src={image} />
          <Button
            variant="contained"
            color="error"
            onClick={() => setFullScreen(null)}
          >
            Close
          </Button>
        </Stack>
      </BigModal>
    </Grid>
  ) : null
})

export default MedicalDrawing
